import type { GAItemListInfo, GAListInformation } from "./types/trackingTypes";

export const buildListInfo = (listInformation?: GAListInformation, position?: number): GAItemListInfo => {
   if (!listInformation) {
      return {};
   }

   return {
      item_list_id: listInformation.type,
      item_list_name: listInformation.name,
      ...(position === undefined ? {} : { index: position })
   };
};
